module.exports = __webpack_public_path__ + "media/images/browsers/ie-3f6ee6c7e9e89bad505355dd8b0512ab.svg";